














import Widget from "@/components/common/Widget.vue";
import VerticalLineAndBarSingleChart from "@/components/charts_js/VerticalLineAndBarSingleChart.vue";
import DashboardItemWrapper from "@/components/DashboardItems/DashboardItemWrapper.vue";
import Vue from "vue";

import Component from "vue-class-component";

@Component({
  components: {
    Widget,
    DashboardItemWrapper,
    VerticalLineAndBarSingleChart,
  },
})
export default class EBITGesamtJahre extends Vue {
  public static id = "EBITGesamtJahre";
  public static dprops = { width: 4, height: 4, minWidth: 2, minHeight: 2 };
  get _id() {
    return EBITGesamtJahre.id;
  }
  get _dprops() {
    return EBITGesamtJahre.dprops;
  }
}
